import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {MatDialog} from "@angular/material/dialog";
import {AddTypeComponent} from "./add-type/add-type.component";
import {EditTypeComponent} from "./edit-type/edit-type.component";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {Observable, Subscription} from "rxjs";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {needConfirmation} from "../../confirm-dialog/confirm-dialog.decorator";
import {UserRole} from "../rename/add-user-role/add-user-role.component";
import {LogService} from "../../services/log.service";
import {PermissionType} from "../employee/PermissionType.enum";

export interface ListType {
    name: string
    id?: string
}

export class TypeData {
    key = ''
    name = ''
}

@Component({
    selector: 'app-types',
    templateUrl: './types.component.html',
    styleUrls: ['./types.component.scss']

})
export class TypesComponent implements OnInit, AfterViewInit, OnDestroy {
    selectedType = '';
    displayType = (o: any) => o?.name;
    mRef: Subscription | undefined;
    displayedColumns: string[] = ['name', 'Actions'];
    typeList$: Observable<ListType[]>
    fieldForm!: FormGroup

    data: Array<TypeData> = []
    dataSource: MatTableDataSource<TypeData>;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
  permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  type=this.permissions.filter((x)=>x.functionName=='Types')


  constructor(private matDialog: MatDialog,
              private mLogService:LogService,
                private mDatabase: AngularFireDatabase) {
        this.dataSource = new MatTableDataSource(this.data);
        this.typeList$ = mDatabase.list<ListType>('typelist').valueChanges()
        this.fieldForm = new FormGroup({
            field: new FormControl('', Validators.required)
        })
    }

    ngOnInit(): void {

    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }


  onTypeSelect(selected: any) {
    this.selectedType = selected?.name || '';
    if (this.selectedType) {
      this.getData(this.selectedType);
    } else {
      this.dataSource.data = [];
    }
  }

  AddType() {
    this.matDialog.open(AddTypeComponent, {
      width: '420px',
    });
  }

  getData(filterValue: string): void {
    // unsubscribe previous
    this.mRef?.unsubscribe();
    this.mRef = this.mDatabase
      .list('types/' + filterValue)
      .snapshotChanges()
      .subscribe(snaps => {
        const tempData: TypeData[] = [];
        snaps.forEach(snap => {
          const a = new TypeData();
          a.key = snap.key as string;
          a.name = snap.payload.val() as string;
          tempData.push(a);
        });
        this.dataSource.data = tempData;
        if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
        }
      });
  }



  @needConfirmation()
  AddTypData() {
    if (this.fieldForm.invalid) {
      this.fieldForm.markAllAsTouched();
      return;
    }
    const key = this.mDatabase.database.ref('types/' + this.selectedType).push().key;
    const field = this.fieldForm.get('field')?.value;
    this.mDatabase.object('types/' + this.selectedType + '/' + key).set(field).then(() => {
      this.fieldForm.reset();
      this.mLogService.addLog({
        date: new Date().getTime(),
        section: 'Types',
        action: 'Submit',
        description: `Types Submit ${field} Master by user`,
        currentIp: localStorage.getItem('currentip')!
      });
    });
  }

  Edit(row: TypeData) {
    this.matDialog.open(EditTypeComponent, {
      width: '420px',
      data: { key: row.key, name: row.name, selectedType: this.selectedType }
    });
  }



  @needConfirmation()
  Delete(key: string) {
    this.mDatabase.object('types/' + this.selectedType + '/' + key).remove().then(() => {
      this.mLogService.addLog({
        date: new Date().getTime(),
        section: 'Types',
        action: 'Delete',
        description: `Types Delete Master by user`,
        currentIp: localStorage.getItem('currentip')!
      });
    });
  }

  ngOnDestroy(): void {
    this.mRef?.unsubscribe();
  }

  protected readonly PermissionType = PermissionType;
}
